import '../styles/Container.css';

const Container = (props) => <div className='container'>{props.children}</div>;

export default Container;
